import React, {useEffect, useState} from "react";
import SimpleLineIcon from "react-simple-line-icons";
import "./Verify.scss";
import {useLocation, useHistory} from "react-router";
import { Spin} from "antd";
import {
    fixNumbers,
    getMallWithSubDomain,
    LoginRequest,
    MessageHandler,
    Validation,
    VerifyRequest
} from "../../Services";
import {isMobile} from "react-device-detect";
import ReactGA from 'react-ga';
import {useDispatchUser, useUser, useDispatchMall} from "../../hooks";
import {MallsData} from "../Malls/MallsServices";
import {CheckinData} from "../Scan/ScanServices";
import toaster from "toasted-notes";
import sha256 from "sha256"
import Logo from "../../assets/images/logo.png";
import {createReferralFormLinkApi} from "../Referral/ReferralServices";
import {CheckinMall, CheckinMallWithToken, GuestBasketSyncApi} from "../StoreDetail/StoreDetailServices";
import useWindowDimensions from "../../hooks/useWindowDimensions";

// import FingerprintJS from '@fingerprintjs/fingerprintjs'
//
// const fpPromise = FingerprintJS.load()

function Error(props) {

    return (
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}


function Verify() {

    //hooks
    const location = useLocation();
    const history = useHistory();
    const setUser = useDispatchUser();
    const setMall = useDispatchMall();


    // states
    const [code, setCode] = useState("");
    const [token, setToken] = useState("");
    const [verifyState, setVerifyState] = useState(false);
    const [btnState, setBtnState] = useState(true);
    const [subMall, set_subMall] = useState(null);
    const [showLogo, set_showLogo] = useState(false);
    const [otpi, set_otpi] = useState("cccccccccc");
    const [resendSpinner, set_resendSpinner] = useState(false);

    const resendCode = async () => {
        set_resendSpinner(true)

        if (!Validation({type: "MOBILE", val: fixNumbers(location.state.mobile)})) {
            return MessageHandler({type: "VALIDATION", status: "MOBILE"})
        }
        //request
        try {
            let response = await LoginRequest({
                phone: fixNumbers(location.state.mobile),
                host_name: window.location.hostname
            })
            set_counter(120)
            set_resendSpinner(false)
            MessageHandler({type:"LOGIN",status:"SUCCESS"})
        }catch (e) {
            set_resendSpinner(false)
            MessageHandler({type:"LOGIN",status:"ERROR"})
        }
    }

    const Otp = () => {
        if ("OTPCredential" in window) {
            const ac = new AbortController();
            navigator.credentials
                .get({
                    otp: {transport: ["sms"]},
                    signal: ac.signal
                })
                .then((otp) => {
                    console.log("Otp Success: ", otp.code);
                    setCode(otp.code);
                    ac.abort();
                })
                .catch((err) => {
                    ac.abort();
                    console.log("Otp error : ", err);
                });
        }
    }

    useEffect(() => {
        //check subdomain
        let full = window.location.hostname; // subdomain.domain.com
        let parts = full.split('.');
        let sub = "";
        let isAdmin = "";

        if (parts.length === 3 && parts[0] !== "www") {
            sub = parts[0]
        } else {
            sub = "app"
        }

        isAdmin = parts[0];

        if (isAdmin === "www" || isAdmin === "test")
            isAdmin = parts[1];

        if (isAdmin === "digimaall" || isAdmin === "test" || isAdmin === "stage" || isAdmin === "localhost" || isAdmin === "apluss" || isAdmin === "app") {
            let temp = isAdmin;
            isAdmin = "digimaall";
            if (temp === "app" && parts[1] !== "apluss") {
                isAdmin = "app"
                console.log("in")
            }
            // if(temp==="app" && parts[1] !== "digimaall"){
            //     isAdmin = "app"
            //     console.log("out")
            // }
        }

        console.log("Sub domain : ", sub)
        getMall(sub)
    }, [])

    const getMall = async (sub) => {
        try {
            const res_getMall = await getMallWithSubDomain(sub);
            console.log("mall : ", res_getMall)
            set_subMall(res_getMall.data)
            set_showLogo(true)
        } catch (e) {
            console.log(e)
            set_showLogo(true)
        }
    }


    useEffect(() => {
        Otp()
        console.log("STATE : ", location)
        if (location.state && location.state.token) {
            setToken(location.state.token)
            // clear history state
            // history.replace('/verify', {...location.state, token: ""});
        }
    }, [])


    const isPublicDomain = () => {
        let full = window.location.hostname; // subdomain.domain.com
        let parts = full.split('.');
        let sub = parts[0];

        if (sub === "www" || sub === "test")
            sub = parts[1];

        if (sub === "digimaall" || sub === "test" || sub === "stage" || sub === "localhost" || sub === "apluss" || sub === "app") {

            return true
        }

        return false
    }


    const HomeRedirect = (st)=>{
        let basketLocal = localStorage.getItem('basket')
        if(basketLocal){
            let basket =  JSON.parse(basketLocal)
            if(basket.length > 0){
                 history.push(`/dr-shop/basket/${basket[0].product.merchant.uid}`)
            }else{
                history.push("/home",st)
            }
        } else{
            history.push("/home",st)
        }
    }

    const dispatchRoute = () => {
        console.log("location ................", location)
        if (location.state && location.state.loginState && location.state.loginState.from && location.state.loginState.from.pathname) {
            if (location.state.loginState.from.pathname === "/") {
                //check subdomain
                if (isPublicDomain()) {
                    history.push("/malls")
                } else {
                    HomeRedirect()
                    // history.push("/home")
                }
            } else {
                if (isPublicDomain()) {
                    history.push("/malls")
                } else {
                    history.push(location.state.loginState.from.pathname, {direct: true})
                }
            }
        } else {
            //check subdomain
            if (isPublicDomain()) {
                history.push("/malls")
            } else {
                HomeRedirect(location.state)
                // history.push("/home", location.state)
            }
        }
    }

    // const getFinger = async ()=>{
    //     const fp = await fpPromise
    //     const result = await fp.get()
    //
    //     // This is the visitor identifier:
    //     const visitorId = result.visitorId
    //     console.log("finger : ",visitorId)
    //     return  visitorId
    // }

    const callInfluencerLink = async (inf) => {

        let obj = {
            "phone": location.state.mobile,
            "inviter_user": inf.user.uid,
            "type": inf.type === "celebrity_merchant_referral" ? 1 : 2,
            "link_uid": inf.referralLink.linkUid
        }

        if (inf.type === "celebrity_merchant_referral")
            obj.merchant = inf.merchant.uid
        if (inf.type === "celebrity_campaign_referral")
            obj.campaign = inf.campaign.uid

        try {
            await createReferralFormLinkApi(obj, inf.referralLink.resourceUid)
            localStorage.removeItem("influencer")
        } catch (e) {
            console.log(e)
        }
    }

    // Login Method -------------------------------------------------------------------
    const Verify_Request = async () => {
        if (verifyState) {
            return
        }

        // pre request
        setVerifyState(true);


        if (!Validation({type: "VERIFY_TOKEN", val: fixNumbers(code)})) {
            MessageHandler({type: "VALIDATION", status: "VERIFY_CODE"})
            setVerifyState(false);
            return;
        }

        if (token.length < 1) {
            MessageHandler({type: "VALIDATION", status: "VERIFY_TOKEN"})
            setVerifyState(false);
            return;
        }

        // console.log("DDDD2 : ")

        //request
        try {

            let fingerId = sha256(window.navigator.userAgent)

            let response = await VerifyRequest({
                code: fixNumbers(code),
                token: token,
                fingerprint: fingerId,
                type: "web"
            })
            //post success request
            setVerifyState(false);
            //MessageHandler({type:"LOGIN",status:"SUCCESS"})

            //set Token to localstorage
            localStorage.setItem('token', response.data.access_token);
            localStorage.setItem('shop_token', response.data.access_token);
            //User Set
            localStorage.setItem('user', JSON.stringify(response.data));
            setUser(response.data);
            //set User GA
            // ReactGA.initialize('UA-175496552-1', {
            //     debug: false,
            //     titleCase: false,
            //     gaOptions: {
            //         userId: 123,
            //         clientId: response.data.phone
            //     }
            // });
            //ReactGA.set({userId:response.data.phone})


            //set Malls

            //first Mall

            //check influencer link
            console.log("check influencer : ")
            let inf = localStorage.getItem("influencer")
            if (inf) {
                let parsed = JSON.parse(inf)

                try {
                    await callInfluencerLink(parsed)
                    if (parsed.type === "celebrity_merchant_referral")
                        await CheckinMallWithToken(parsed.merchant.mall.uid, response.data.access_token)
                    if (parsed.type === "celebrity_campaign_referral")
                        await CheckinMallWithToken(parsed.campaign.mall.uid, response.data.access_token)
                } catch (e) {
                    console.log(e)
                }
            }

            //check gustBasket
            let guestBasketLocal = localStorage.getItem("basket")
            if (guestBasketLocal) {
                let guestBasketData = JSON.parse(guestBasketLocal);
                if (guestBasketData.length > 0) {
                    let product_list = guestBasketData.map(g => {
                        return {
                            product_id: g.product?.uid,
                            merchant_uid: g.product?.merchant?.uid,
                            quantity: g.count
                        }
                    })


                    let payload = {
                        merchant_uid: guestBasketData[0].product?.merchant?.uid,
                        product_list: product_list
                    }

                    try {
                        let response = await GuestBasketSyncApi(payload);
                        localStorage.setItem('guestBasketResponse',JSON.stringify(response.data));
                    } catch (e) {
                        console.log(e)
                    }
                }

            }


            try {
                if (!location.state.mall) {
                    let malls = await MallsData();
                    //let malls = {data:[]}
                    // console.log("DATA 0 ",malls)
                    if (malls.data.length < 1) {
                        localStorage.removeItem('mallId');
                        localStorage.removeItem('merchants');
                        localStorage.removeItem('mallLogo');
                        localStorage.removeItem('mallName');
                        localStorage.removeItem('mall');
                        localStorage.removeItem('user');
                        localStorage.removeItem('cats');
                        localStorage.removeItem('wait');
                        localStorage.removeItem('token');
                        localStorage.removeItem('shop_token');
                        localStorage.removeItem('allowNotif');
                        localStorage.removeItem('basket');
                        localStorage.removeItem('mobileSuggestion');
                        localStorage.removeItem('active_tab');
                        // console.log("DATA 1 ")
                        toaster.notify(({onClose}) => (
                            <Error message={"محتوایی برای نمایش وجود ندارد"}/>), {duration: 2000});
                        setTimeout(() => {
                            history.push('/login');
                        }, 3000)

                    } else {
                        //domain condition
                        if (isPublicDomain()) {
                            localStorage.setItem('mallId', malls.data[0].uid);
                            localStorage.setItem('mallLogo', malls.data[0].header_image);
                            localStorage.setItem('mallWhite', malls.data[0].logo);
                            localStorage.setItem('mallName', malls.data[0].name);
                            localStorage.setItem('mall', JSON.stringify(malls.data[0]));
                            setMall(malls.data[0]);
                            // console.log("DATA 2 ")
                            dispatchRoute()
                            // history.push('/home')
                        } else {
                            if (subMall.uid) {
                                localStorage.setItem('mallId', subMall.uid);
                                localStorage.setItem('mallLogo', subMall.header_image);
                                localStorage.setItem('mallWhite', subMall.logo);
                                localStorage.setItem('mallName', subMall.name);
                                localStorage.setItem('mall', JSON.stringify(subMall));
                                setMall(malls.data[0]);

                                dispatchRoute()
                            }
                        }

                    }

                } else {
                    // console.log("/Malllllllll",location.state.mall)
                    let malli = location.state.mall;
                    await CheckinData("mc_" + malli.uid)
                    localStorage.setItem('mallId', malli.uid);
                    localStorage.setItem('mallLogo', malli.header_image);
                    localStorage.setItem('mallWhite', malli.logo);
                    localStorage.setItem('mallName', malli.name);
                    localStorage.setItem('mall', JSON.stringify(malli));
                    setMall(malli);
                    // console.log("DATA 3 ")
                    //dispatchRoute()
                    HomeRedirect()
                    // history.push('/home')
                }
            } catch (e) {
                // console.log("DATA 4 ")
                // console.log(e)
            }


        } catch (e) {

            console.log("ccccccccccccc : ",e)

            //post failed request
            setVerifyState(false);
            MessageHandler({type: "VALIDATION", status: "VERIFY_TOKEN"})
        }
    }

    const updateWindowDimensions = () => {
        if (window.innerHeight < 380) {
            setBtnState(false)
        } else {
            setBtnState(true)
        }
    }

    useEffect(() => {
        window.addEventListener('resize', updateWindowDimensions);
        return () => {
            window.addEventListener('resize', updateWindowDimensions)
        }
    }, [])

    const onEnter = (event, callback) => event.key === 'Enter' && callback()
    const enterEvent = () => Verify_Request();

    const {height, width, mobileWidth} = useWindowDimensions();

    const [counter,set_counter] = useState(120)

    useEffect(()=>{
       setInterval(()=>{
           set_counter(c=>c-1)
       },1000)
    },[])

    return (
        <div className="login-container">
            <div className="otp-container">

                <div className="otp-top">

                    {/*{showLogo ? <div className="otp-logo">*/}
                    {/*    {subMall && subMall.logo ? <img src={subMall.logo} alt={subMall.name}/> :*/}
                    {/*        <img src={Logo} alt="Digi Mall"/>}*/}
                    {/*</div> : null}*/}

                    <h2>{subMall?.name}</h2>

                </div>


                <div className="otp-mobile-text-sec">
                    <span className="otp-mobile-text">کد برای شماره</span>
                    <span className="otp-mobile-number">{location.state?.mobile}</span>
                    <span className="otp-mobile-text">ارسال شد</span>
                </div>
                <div className="otp-input-verify">
                    <input
                        value={code}
                        onFocus={() => {
                            if (isMobile) {
                                setBtnState(false)
                            }
                        }}
                        onBlur={() => {
                            setTimeout(() => {
                                setBtnState(true)
                            }, 100)
                        }}
                        onChange={(e) => {
                            setCode(e.target.value)
                        }}
                        onKeyPress={e => onEnter(e, enterEvent)}
                        pattern="[0-9]*" inputMode="numeric"
                        type="text" name="" id="" placeholder="کد فعال سازی ۴ رقمی"/>
                    <SimpleLineIcon name="lock"/>
                </div>
                <Spin spinning={resendSpinner}>
                    <div className="otp-mobile-back-link">
                        {counter>0?

                            <span className="counter">{counter}</span>:
                            <span className="back-link clickable" onClick={() => {
                                resendCode()
                            }}>ارسال مجدد کد تایید</span>
                        }
                        <span className="back-link clickable" onClick={() => {
                            history.goBack()
                        }}>برگشت</span>
                    </div>
                </Spin>



                <div className="static-login-btn" onClick={Verify_Request}>
                    {verifyState ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-arrow-left"></i>}
                    ورود
                    <span style={{fontSize: 17}}></span>
                </div>


                {/*{btnState?<div className="top-float-send-btn" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>*/}
                {/*    <div className="float-btn" onClick={Verify_Request}>*/}
                {/*        {verifyState?<i className="fa fa-spinner fa-spin"></i>:<i className="fa fa-arrow-left"></i>}*/}
                {/*        ورود*/}
                {/*        <span style={{fontSize:17}}></span>*/}
                {/*    </div>*/}
                {/*</div>:null}*/}

            </div>
        </div>
    )
}

export {Verify}

